import { useState } from "react";
import { Button } from "./Button";

const CLOSE_ANIMATION_MS = 200;

function FilterPill({ active, label, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`px-4 py-1 rounded-full text-sm font-medium border ${
        active ? "text-white border-transparent" : "text-[#7A8A90] border-[#DCE3E6] border-[.5px] bg-white"
      }`}
      style={active ? { background: "#0F4C5C" } : {}}
    >
      {label}
    </button>
  );
}

export default function FilterSheet({
  title,
  typeOptions,
  statusOptions,
  typeValue,
  statusValue,
  onApply,
  onClose,
}) {
  const hasType = Boolean(typeOptions);
  const [draftType, setDraftType] = useState(typeValue);
  const [draftStatus, setDraftStatus] = useState(statusValue);
  const [closing, setClosing] = useState(false);

  const closeWithAnimation = (after) => {
    setClosing(true);
    setTimeout(after, CLOSE_ANIMATION_MS);
  };

  const handleClose = () => closeWithAnimation(onClose);
  const handleApply = (type, status) => closeWithAnimation(() => onApply(type, status));

  return (
    <div className="fixed inset-0 z-50 md:hidden">
      <div
        className={`absolute inset-0 bg-black/40 ${closing ? "animate-fade-out" : "animate-fade-in"}`}
        onClick={handleClose}
      />
      <div
        className={`absolute bottom-0 left-0 right-0 bg-white rounded-t-2xl p-5 max-h-[85vh] overflow-auto ${
          closing ? "animate-slide-down" : "animate-slide-up"
        }`}
      >
        <div className="w-10 h-1 bg-gray-200 rounded-full mx-auto mb-4" />
        <div className="flex items-center justify-between mb-5">
          <h2 className="text-base font-semibold text-gray-800">{title}</h2>
          <Button variant="tertiary" onClick={handleClose} aria-label="Close" className="!p-1">
            <img src="/assets/close.svg" alt="" width={18} height={18} />
          </Button>
        </div>

        {hasType && (
          <div className="mb-5">
            <div className="text-sm text-gray-400 mb-2">Type</div>
            <div className="flex flex-wrap gap-2">
              {typeOptions.map((opt) => (
                <FilterPill
                  key={opt.value}
                  label={opt.label}
                  active={draftType === opt.value}
                  onClick={() => setDraftType(opt.value)}
                />
              ))}
            </div>
          </div>
        )}

        <div className="mb-6">
          <div className="text-sm text-gray-400 mb-2">Status</div>
          <div className="flex flex-wrap gap-2">
            {statusOptions.map((opt) => (
              <FilterPill
                key={opt.value}
                label={opt.label}
                active={draftStatus === opt.value}
                onClick={() => setDraftStatus(opt.value)}
              />
            ))}
          </div>
        </div>

        <div className="flex gap-3">
          <Button
            variant="secondary"
            onClick={() => {
              setDraftType("");
              setDraftStatus("");
              handleApply("", "");
            }}
            className="flex-1"
          >
            Clear All
          </Button>
          <Button
            onClick={() => handleApply(draftType, draftStatus)}
            className="flex-1"
            style={{ background: "#2d7a7a" }}
          >
            Apply Filters
          </Button>
        </div>
      </div>
    </div>
  );
}
